import { render } from "./HeroiconsSolidInformationCircle.vue?vue&type=template&id=3fe6e886"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidInformationCircle.vue"]])

export default __exports__